export interface Searchable<W, R> {
  search(params: W): Promise<{
    items?: R[];
  }>;
}

export async function fetchAllInBatches<W, R>(service: Searchable<W, R>, params: W, takeUntil?: number): Promise<R[]> {
  const limit = 200;

  let items: R[] = [];
  let offset = 0;
  let total = 0;
  let takeMore = true;
  do {

    const result = await service.search({
      ...params,
      limit,
      offset
    });

    items = items.concat(result.items);
    total = result.items.length;
    offset += limit;
    takeMore = takeUntil ? items.length < takeUntil : true;

  } while (total >= limit && takeMore);

  return items;
}
